<div class="top-bar">
  <div class="scroller">
    <div class="track">
      <div class="content d-flex align-items-center">
        <div class="d-flex align-items-center" *ngFor="let item of messageList">
          <p class="font-20 text-white m-0 mx-2">
            {{ item.text | translate }}
          </p>
        </div>
        <div class="d-flex align-items-center" *ngFor="let item of messageList">
          <p class="font-20 text-white m-0 mx-2">
            {{ item.text | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
